(function ($) {
    window.Actions = {
        asyncCall: function (callback, args, context, delay) {
            window.setTimeout(function() {
                callback.apply(context || null, args || [])
            }, delay || 50);
        },

        showLoading: function () {
            $('body').addClass('loading');
        },

        hideLoading: function () {
            $('body').removeClass('loading');
        },

        blurContent: function blurContent (selector) {
            $(selector).addClass('blur');
        },

        clarifyContent: function clarifyContent (selector) {
            $(selector).removeClass('blur');
        },

        hideTooltip: function hideTooltip (selector) {
            $(selector)
                .removeClass('show')
                .attr('data-date', Date.now())
                .attr('data-display', 'hidden');
        },

        showTooltip: function showTooltip (selector, duration) {
            duration = duration || 5000;

            window.setTimeout(function () {
                $(selector)
                    .addClass('show')
                    .attr('data-date', Date.now())
                    .attr('data-display', 'visible');
            }, 0);

            window.setTimeout(function () {
                if ($(selector).attr('data-display') == 'visible' && Date.now()-duration+100 >= $(selector).attr('data-date'))
                    window.Actions.hideTooltip(selector);
            }, duration);
        },

        openTransition: function (selector) {
            $(selector).attr('data-state', 'open');
        },

        closeTransition: function (selector) {
            $(selector).attr('data-state', 'close');
        },

        openGenericPopup: function openGenericPopup (selector, delay) {
            var el = $(selector);

            el.removeClass('remove');
            el.addClass('hide');

            window.setTimeout(function () {
                el = $(selector);
                el.addClass('show');
                el.removeClass('hide');
            }, delay || 0);
        },

        closeGenericPopup: function closeGenericPopup (selector, delay) {
            var el = $(selector);

            el.addClass('hide');
            el.removeClass('show');

            window.setTimeout(function () {
                el = $(selector);
                el.removeClass('hide');
                el.addClass('remove')
            }, delay || 300);
        },

        showTooltipWarning: function (selector, condition) {
            if( condition() ) {
                Actions.showTooltip($(selector));
                return true;
            }

            return false;
        },
        clearFilters: function clearFilters() {
            //add loading
            $('body').addClass('loading');
            //Clear filters
            whereToGo = $.ModuleUtil.calculateModule();
            jQuery(".sortType" + whereToGo).val("clearFilters###all"  );
            if (whereToGo === 'broadwithHotel'){
                for (let i = 0; i < 3; i++) {
                    let str = $('.room'+i+'childAge').val();
                    $('.room'+i+'childAge').val(str.replace(/[\[\] ]+/g,''));
                }
            }
            jQuery("." + whereToGo).find(':submit').trigger("click");
        },
        toggleTextHeight: function (selector, expand) {
            var textElement = $(selector),
                minHeight   = textElement.attr("data-maxHeight") || 24;

            if (!textElement.hasClass('limitedText') || textElement.hasClass('expansionDisabled'))
                return false;

            if (typeof expand !== 'boolean')
                expand = !textElement.hasClass('expanded') && textElement.css("max-height") !== '100%';

            if (expand) {
                textElement.addClass("expanded");
                textElement.css("max-height", "100%");
            } else {
                textElement.removeClass("expanded");
                textElement.css("max-height", minHeight + "px");
            }

            return true;
        },
        handleLimitedText: function (selector) {
            var element     = $(selector),
                maxHeight   = element.attr('data-maxHeight'),
                innerEl     = element.find('.limitedText__inner'),
                height      = innerEl.height();

            if (height <= maxHeight) {
                element.addClass('expansionDisabled');
            } else {
                element.removeClass('expansionDisabled');
            }
        }
    }
})($);